module.exports = __webpack_public_path__ + "static/media/LinkedIn.2fef1a57.svg";